/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import { GR8PI_LOCALE_STORE_KEY } from '../../utils/Gr8piConfig';

export const saveViewerLocale = (locale) => {
  localStorage.setItem(
    GR8PI_LOCALE_STORE_KEY,
    locale,
  );
};

export const getViewerLocale = () => localStorage.getItem(GR8PI_LOCALE_STORE_KEY);

export const clearViewerLocale = () => {
  localStorage.setItem(
    GR8PI_LOCALE_STORE_KEY,
    null,
  );
};
